import Vue from 'vue';
import Errors from '../classes/Errors';

Vue.component('join-the-pack-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            formCompleted: false,
            submitting: false,
            formLoadedAt: Math.floor(Date.now() / 1000),
        };
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onSubmit(event) {
            const form = event.currentTarget;

            if (this.submitting) {
                return;
            }

            this.submitting = true;

            axios.post('/', new FormData(form))
                .then((response) => {
                    this.submitting = false;
                    const result = response.data;

                    if (result.data && result.data.errors) {
                        this.errors.clear();
                        this.errors.record(result.data.errors);
                        return;
                    }

                    // Success
                    this.formCompleted = true;
                    this.errors.clear();

                    if (this.$refs.redirectUrl) {
                        window.location = this.$refs.redirectUrl.value;
                        return;
                    }
                })
                .catch((error) => {
                    this.submitting = false;
                    console.log(error);
                });
        }
    }
});
